import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAppContext } from '../../context/AppContext';
import SafeIcon from '../../common/SafeIcon';
import { FiMap, FiList, FiPlusSquare, FiUser, FiShield, FiMenu, FiX } from 'react-icons/fi';

const Navbar = () => {
  const { user, isAdmin } = useAppContext();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Discover', path: '/', icon: FiList },
    { name: 'Adventure Map', path: '/map', icon: FiMap },
  ];

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <nav className="bg-white/80 backdrop-blur-md border-b border-stone-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-3 group">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/8004b964219a2ec88a1ae2cf7702d68f059f7f87c6ce7c7516e333ff7734f22eeed8a0cb5324bfb74e1bfd7e577adf83/images/aW1hZ2UvcG5n/305d89ddb15526c0a8696a19dbdba1cf.png" 
                alt="Adventure Jobs Logo" 
                className="w-10 h-10 sm:w-12 sm:h-12 object-contain group-hover:scale-105 transition-transform"
              />
              <span className="text-xl sm:text-2xl font-black tracking-tight text-stone-900 hidden xs:block">
                ADVENTURE<span className="text-emerald-500">JOBS</span>
              </span>
            </Link>
            
            <div className="hidden md:ml-10 md:flex md:space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`inline-flex items-center px-1 pt-1 text-sm font-bold transition-colors border-b-2 ${
                    location.pathname === link.path
                      ? 'border-emerald-500 text-stone-900'
                      : 'border-transparent text-stone-500 hover:text-emerald-500 hover:border-emerald-200'
                  }`}
                >
                  <SafeIcon icon={link.icon} className="mr-2" />
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="flex items-center gap-2 sm:gap-3">
            {/* Moderation Button - Prominent for Admins */}
            {isAdmin && (
              <Link
                to="/admin"
                className="flex items-center gap-2 px-3 sm:px-4 py-2 text-xs sm:text-sm font-bold text-amber-700 bg-amber-50 rounded-lg hover:bg-amber-100 transition-colors border border-amber-200"
                title="Admin Command Center"
              >
                <SafeIcon icon={FiShield} />
                <span className="hidden xs:inline">Moderation</span>
              </Link>
            )}

            <Link
              to="/employer/post-job"
              className="hidden sm:flex items-center gap-2 px-4 py-2 text-sm font-bold text-white bg-stone-900 rounded-lg hover:bg-stone-800 transition-all hover:shadow-lg active:scale-95"
            >
              <SafeIcon icon={FiPlusSquare} />
              Post a Job
            </Link>
            
            <Link
              to={user ? "/employer/dashboard" : "/employer/login"}
              className="hidden sm:flex items-center gap-2 p-2 sm:px-4 sm:py-2 text-sm font-bold text-stone-700 hover:text-emerald-500 transition-colors rounded-lg hover:bg-emerald-50"
            >
              <SafeIcon icon={FiUser} className="text-lg" />
              <span>{user ? 'Dashboard' : 'Employer Login'}</span>
            </Link>

            <button
              onClick={toggleMenu}
              className="md:hidden p-2 text-stone-600 hover:text-emerald-500 transition-colors"
            >
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="text-2xl" />
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-white border-b border-stone-200 px-4 py-4 space-y-3 animate-in slide-in-from-top duration-200">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center gap-3 px-4 py-3 text-base font-bold text-stone-700 hover:bg-emerald-50 hover:text-emerald-600 rounded-xl transition-colors"
            >
              <SafeIcon icon={link.icon} />
              {link.name}
            </Link>
          ))}
          
          <hr className="border-stone-100 mx-4" />

          {isAdmin && (
            <Link
              to="/admin"
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center gap-3 px-4 py-3 text-base font-bold text-amber-700 bg-amber-50 hover:bg-amber-100 rounded-xl transition-colors border border-amber-100"
            >
              <SafeIcon icon={FiShield} />
              Moderation Center
            </Link>
          )}

          <Link
            to="/employer/post-job"
            onClick={() => setIsMenuOpen(false)}
            className="flex items-center gap-3 px-4 py-3 text-base font-bold text-white bg-stone-900 hover:bg-stone-800 rounded-xl transition-colors"
          >
            <SafeIcon icon={FiPlusSquare} />
            Post a Job
          </Link>

          <Link
            to={user ? "/employer/dashboard" : "/employer/login"}
            onClick={() => setIsMenuOpen(false)}
            className="flex items-center gap-3 px-4 py-3 text-base font-bold text-stone-700 hover:bg-emerald-50 rounded-xl transition-colors"
          >
            <SafeIcon icon={FiUser} />
            {user ? 'Dashboard' : 'Employer Login'}
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;